import { Store } from 'redux';
import { ApplicationState } from './types';

class StoreContainer {
  private storeInstance?: Store<ApplicationState>;

  get store(): Store<ApplicationState> {
    if (!this.storeInstance) {
      throw new Error('Cannot get Store Instance, because store has not been configured.');
    }

    if (module.hot) {
      module.hot.accept('./', () =>
        // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
        this.storeInstance!.replaceReducer(require('./').createRootReducer(window.history)),
      );
    }

    return this.storeInstance;
  }

  setStore(storeInstance: Store<ApplicationState>) {
    this.storeInstance = storeInstance;
  }
}

export default new StoreContainer();
